// ============================================================================
// Mock data — zdrojová data pro skeleton
// Ve Fázi 3-4 bude nahrazeno reálnými daty z Netlify Functions endpointů
// ============================================================================

// ----- P&L / Cashflow (dle CF LE-2026) -----
export const mockPL = {
  year: 2026,
  currentMonth: 4,
  months: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
  revenue: {
    Coaching: [245000, 410000, 420000, 400000, 505000, 620000, 605000, 675000, 765000, 675000, 675000, 765000],
    B2B: [15000, 22000, 20000, 18000, 25000, 30000, 30000, 30000, 35000, 30000, 30000, 35000],
    Products: [8000, 14000, 15000, 15000, 20000, 25000, 22000, 28000, 32000, 28000, 28000, 32000],
    Provision: [3000, 6000, 6000, 6000, 7000, 8000, 7500, 9000, 10000, 9000, 9000, 10000],
    "Loans/Investments": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    VAT: [2041, 4172, 5137, 5699, 4983, 7186, 5686, 8186, 8186, 8186, 8186, 8186],
  },
  revenueTotal: [273041, 456172, 466137, 444699, 561983, 690186, 670186, 750186, 850186, 750186, 750186, 850186],
  opex: {
    "Marketing & Sales": {
      total: [65000, 72000, 71000, 85000, 75000, 88000, 95000, 95000, 100000, 100000, 95000, 95000],
      sub: {
        "Ads (FB, Google, Seznam)": [45000, 51000, 51243, 62000, 55000, 65000, 70000, 70000, 75000, 75000, 70000, 70000],
        "Brand & graphics": [5000, 6000, 6000, 8000, 6000, 7000, 8000, 8000, 8000, 8000, 8000, 8000],
        "Marketing manager": [10000, 10000, 10000, 10000, 10000, 12000, 12000, 12000, 12000, 12000, 12000, 12000],
        Sales: [5000, 5000, 3757, 5000, 4000, 4000, 5000, 5000, 5000, 5000, 5000, 5000],
      },
    },
    "General & Administrative": {
      total: [185000, 215000, 205000, 290000, 215000, 265000, 305000, 295000, 295000, 320000, 300000, 300000],
      sub: {
        CEO: [45000, 50000, 48000, 70000, 50000, 60000, 72000, 70000, 70000, 80000, 70000, 70000],
        COO: [35000, 40000, 38000, 55000, 40000, 48000, 57000, 55000, 55000, 60000, 58000, 58000],
        "Head Coach Senior": [30000, 35000, 33000, 50000, 35000, 42000, 52000, 50000, 50000, 55000, 50000, 50000],
        "Head of Clients Success": [25000, 30000, 28000, 45000, 30000, 38000, 47000, 45000, 45000, 50000, 45000, 45000],
        "HR Recruiter": [10000, 12000, 12000, 18000, 12000, 14000, 18000, 16000, 16000, 20000, 18000, 18000],
        "Office manager": [15000, 18000, 18000, 25000, 18000, 22000, 26000, 25000, 25000, 27000, 25000, 25000],
        "Accounting & Legal": [8000, 10000, 10000, 12000, 10000, 11000, 12000, 12000, 12000, 12000, 12000, 12000],
        "Office rent": [10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000],
        Apps: [4000, 5000, 4000, 4000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000],
        "Others (electricity, etc.)": [3000, 5000, 4000, 1000, 5000, 5000, 6000, 7000, 7000, 1000, 7000, 7000],
      },
    },
    Production: {
      total: [95000, 110000, 108000, 130000, 135000, 170000, 200000, 195000, 205000, 215000, 200000, 200000],
      sub: {
        Trainers: [60000, 70000, 68000, 80000, 85000, 105000, 125000, 120000, 125000, 135000, 125000, 125000],
        "Nutritionists & Therap.": [15000, 18000, 18000, 25000, 25000, 35000, 40000, 40000, 45000, 45000, 40000, 40000],
        "Products for clients": [8000, 10000, 10000, 12000, 12000, 15000, 20000, 20000, 20000, 20000, 20000, 20000],
        "Clients events": [7000, 7000, 7000, 8000, 8000, 10000, 10000, 10000, 10000, 10000, 10000, 10000],
        "Nutrition plan creation": [5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000],
      },
    },
    "R&D & Systems": {
      total: [15000, 18000, 18000, 30000, 28000, 38000, 45000, 45000, 45000, 55000, 45000, 45000],
      sub: {
        "R&D of products": [5000, 8000, 8000, 15000, 12000, 20000, 25000, 25000, 25000, 30000, 25000, 25000],
        Education: [5000, 5000, 5000, 10000, 10000, 12000, 12000, 12000, 12000, 15000, 12000, 12000],
        "IT support": [5000, 5000, 5000, 5000, 6000, 6000, 8000, 8000, 8000, 10000, 8000, 8000],
      },
    },
    "Others & Backup": {
      total: [18000, 20000, 22000, 22000, 22000, 22000, 28000, 28000, 28000, 37000, 37000, 37000],
      sub: {
        "General shopping": [5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 10000, 10000, 10000],
        Reserves: [5000, 5000, 5000, 5000, 5000, 5000, 10000, 10000, 10000, 10000, 10000, 10000],
        "Travel costs & car": [4000, 5000, 6000, 6000, 6000, 6000, 7000, 7000, 7000, 7000, 7000, 7000],
        Teambuilding: [2000, 3000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 7000, 7000, 7000],
        "Taxes & Levies (VAT)": [2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 3000, 3000, 3000],
      },
    },
  },
  opexTotal: [378000, 435000, 424000, 557000, 475000, 583000, 673000, 658000, 673000, 727000, 677000, 677000],
  financialExp: [3662, 4646, 6468, 4816, 4262, 3904, 5504, 6179, 6904, 6904, 7904, 7904],
  costsTotal: [381662, 439646, 430468, 561816, 479262, 586904, 678504, 664179, 679904, 733904, 684904, 684904],
  ebit: [-108621, 16526, 35669, -117117, 82722, 103282, -8318, 86007, 170282, 16282, 65282, 165282],
  intramonthDuben: [
    { day: 1, cumRev: 12500, cumCosts: 8000 },
    { day: 3, cumRev: 35800, cumCosts: 24000 },
    { day: 5, cumRev: 68400, cumCosts: 52000 },
    { day: 7, cumRev: 102300, cumCosts: 89000 },
    { day: 9, cumRev: 148600, cumCosts: 142000 },
    { day: 11, cumRev: 195400, cumCosts: 168000 },
    { day: 13, cumRev: 256800, cumCosts: 195000 },
    { day: 14, cumRev: 298400, cumCosts: 210000 },
    { day: 15, cumRev: null, cumCosts: null },
    { day: 20, cumRev: null, cumCosts: null },
    { day: 25, cumRev: null, cumCosts: null },
    { day: 30, cumRev: null, cumCosts: null },
  ],
  intramonthPlan: 444699,
};

// ----- Přehled -----
export const mockOverview = {
  activeClients: 122,
  monthlyRevenueLive: 298400,
  monthlyGoal: 750000,
  monthlyGoalPct: 40,
  mktSpendLive: 23140,
  mktSpendPending: 15200,
  capacityPct: 82,
  trialPotential14d: 187000,
  trialPotentialTotal: 287000,
  cfPlanMonth: 444699,
  cfActualMonth: 298400,
  cfActualPct: 67,
  keyAlerts: [
    {
      id: 1,
      severity: "warning",
      campaign: "FW40 - Jarní akce",
      message: "CPL vzrostl o 45 % za posledních 7 dní",
      detail: "Průměrné CPL 612 Kč (ref. týden 422 Kč). Denní spend drží úroveň, konverze klesly.",
      action: "Zkontrolovat kampaň",
    },
    {
      id: 2,
      severity: "success",
      campaign: "FW40 - Retargeting",
      message: "Konverze o 20 % nad průměrem",
      detail: "ROI 340 % — nejlepší výkon za poslední 4 týdny.",
      action: "Navýšit budget",
    },
    {
      id: 3,
      severity: "info",
      campaign: "FW40 - Brand awareness",
      message: "Kampaň běží 42 dní, lze vyhodnotit",
      detail: "Splňuje pravidlo 'min 30 dní + min 500 leads'.",
      action: "Naplánovat analýzu",
    },
  ],
};

// ----- Daily -----
export const mockDaily = {
  dates: { today: "14. 4. 2026", yesterday: "13. 4. 2026" },
  today: { mktSpend: 2134, newLeads: 5, newTrials: 2, revenueExisting: 12800, revenueNew: 5600 },
  yesterday: { mktSpend: 1987, newLeads: 4, newTrials: 1, revenueExisting: 11400, revenueNew: 8400 },
};

// ----- Weekly -----
export const mockWeekly = {
  availableWeeks: [
    { id: "2026-W15", label: "Týden 15 (6.–12. 4. 2026)" },
    { id: "2026-W14", label: "Týden 14 (30. 3.–5. 4. 2026)" },
    { id: "2026-W13", label: "Týden 13 (23.–29. 3. 2026)" },
    { id: "2026-W12", label: "Týden 12 (16.–22. 3. 2026)" },
  ],
  mkt: { spend: 14560, leads: 32, deals: 8, cpl: 455, roi: 285 },
  trial: { trial: 8, qTrial: 6, churn: 3, converted: 7, prohra: 2, potentialProfit: 172800 },
  funnel: [
    { stage: "Kvalifikace", count: 28 },
    { stage: "Trial", count: 8 },
    { stage: "QTrial", count: 6 },
    { stage: "Deal/Uzavřeno", count: 7 },
  ],
  cplTrend: [
    { week: "T12", cpl: 432 },
    { week: "T13", cpl: 446 },
    { week: "T14", cpl: 441 },
    { week: "T15", cpl: 455 },
  ],
};

// ----- Monthly -----
export const mockMonthly = {
  availableMonths: [
    { id: "2026-03", label: "Březen 2026" },
    { id: "2026-02", label: "Únor 2026" },
    { id: "2026-01", label: "Leden 2026" },
    { id: "2025-12", label: "Prosinec 2025" },
  ],
  monthLabel: "Březen 2026",
  mktSpend: 51243,
  revenue: 466137,
  costs: 430468,
  margin: 35669,
  marginPct: 8,
  avgRevenueLongTerm: 612000,
  yoyRevenue: 388000,
  avgCLV: 52400,
  avgDuration: 10.4,
  avgDealPrice: 48200,
  avgLeadPrice: 455,
  contactSources: [
    { name: "Facebook", count: 42, color: "#1877f2" },
    { name: "Google", count: 18, color: "#34a853" },
    { name: "Doporučení", count: 12, color: "#d97706" },
    { name: "Přednášky", count: 6, color: "#6E519F" },
    { name: "Instagram", count: 9, color: "#e4405f" },
    { name: "Jiné", count: 4, color: "#695C74" },
  ],
  pipelineSnapshot: [
    { stage: "Lead", count: 18 },
    { stage: "Kvalifikace", count: 14 },
    { stage: "Trial", count: 8 },
    { stage: "Deal", count: 5 },
    { stage: "Uzavřeno", count: 22 },
    { stage: "Prohra", count: 9 },
  ],
  trainers: [
    { name: "Láďa Žatečka", clients: 18, avgDuration: 14.2, topPackage: "Koučink GOLD 2T", avgProfit: 8200 },
    { name: "Petr Janata", clients: 22, avgDuration: 11.8, topPackage: "BB2T", avgProfit: 6800 },
    { name: "Michal Šulc", clients: 15, avgDuration: 9.5, topPackage: "PREMIUM 2T", avgProfit: 9100 },
    { name: "Tinka", clients: 12, avgDuration: 13.0, topPackage: "FLEXIBLE 1T", avgProfit: 5400 },
    { name: "Michaela Ryšková", clients: 14, avgDuration: 10.2, topPackage: "BB1T", avgProfit: 4800 },
    { name: "Jakub Mikoláš", clients: 11, avgDuration: 8.5, topPackage: "Koučink GOLD 1T", avgProfit: 5900 },
    { name: "Tomáš Janata", clients: 9, avgDuration: 7.8, topPackage: "BB3T", avgProfit: 7200 },
    { name: "Jan Reichrich", clients: 13, avgDuration: 12.0, topPackage: "Koučink GOLD 2T", avgProfit: 7500 },
    { name: "Anastasiia Vozniuk", clients: 8, avgDuration: 6.5, topPackage: "BT1T", avgProfit: 4200 },
  ],
};

// ----- Yearly -----
export const mockYearly = {
  year: 2026,
  revenueByMonth: mockPL.months.map((m, i) => ({
    month: m,
    revenue: mockPL.revenueTotal[i],
    lastYear: [210000, 265000, 388000, 360000, 480000, 612000, 588000, 660000, 732000, 660000, 660000, 742000][i],
  })),
  totals: { revenue: 7260000, costs: 7025000, profit: 235000, mktSpend: 1035000, roiMkt: 701 },
  avgCLV: 54600,
  avgCLD: 10.8,
  avgDealPrice: 49800,
  avgLeadPrice: 462,
  newVsChurn: [
    { month: "Led", newClients: 12, churned: 4 },
    { month: "Úno", newClients: 18, churned: 6 },
    { month: "Bře", newClients: 14, churned: 5 },
    { month: "Dub", newClients: 15, churned: 3 },
  ],
  packagesYTD: [
    { name: "Koučink GOLD 2T", value: 32, color: "#d97706" },
    { name: "BB2T", value: 24, color: "#2563eb" },
    { name: "BB1T", value: 18, color: "#3b82f6" },
    { name: "PREMIUM 2T", value: 14, color: "#6E519F" },
    { name: "FLEXIBLE 1T", value: 8, color: "#059669" },
    { name: "Ostatní", value: 4, color: "#6b7280" },
  ],
  topTrainers: mockMonthly.trainers.slice().sort((a, b) => b.clients - a.clients).slice(0, 5),
};

// ----- Total stats -----
export const mockStats = {
  totalClientsEver: 487,
  activeClients: 122,
  totalRevenueYear: 6840000,
  totalRevenueAllTime: 28450000,
  avgClientDuration: 10.8,
  packageDistribution: [
    { name: "Koučink GOLD 1T", value: 12, color: "#fbbf24" },
    { name: "Koučink GOLD 2T", value: 20, color: "#d97706" },
    { name: "BB1T", value: 14, color: "#3b82f6" },
    { name: "BB2T", value: 18, color: "#2563eb" },
    { name: "BB3T", value: 6, color: "#1e40af" },
    { name: "PREMIUM 2T", value: 10, color: "#6E519F" },
    { name: "PREMIUM 3T", value: 4, color: "#5F4690" },
    { name: "FLEXIBLE 1T", value: 8, color: "#10b981" },
    { name: "FLEXIBLE 2T", value: 4, color: "#059669" },
    { name: "BT / Výživa", value: 4, color: "#6b7280" },
  ],
  capacity: { totalHours: 228, bookedHours: 187, utilizationPct: 82 },
  aiInsights: [
    {
      id: 1,
      category: "Trenéři",
      insight: "Anastasiia Vozniuk má o 40 % kratší průměrnou spolupráci než tým (6.5 vs 10.8 měs.)",
      recommendation: "Zvaž 1:1 schůzku s Anastasiií a analýzu klientských feedbacků.",
      generated: "včera 06:00",
    },
    {
      id: 2,
      category: "Balíčky",
      insight: "FLEXIBLE 1T klienti mají 2× vyšší churn rate než BB2T klienti, přestože mají podobnou průměrnou cenu.",
      recommendation: "Zvaž úpravu FLEXIBLE 1T: vyšší frekvence kontaktu nebo změnu cenového modelu.",
      generated: "včera 06:00",
    },
    {
      id: 3,
      category: "Marketing",
      insight: "Zdroj 'Doporučení' má nejvyšší konverzi (78 %), ale tvoří jen 12 % leadů.",
      recommendation: "Zvyš investici do referral programu — potenciál ROI 340 %+.",
      generated: "8. 4. 2026",
    },
  ],
};

// ----- Users (Settings) -----
export const mockUsers = [
  { id: 1, name: "Ladislav Žatečka", phone: "+420 777 123 456", role: "Owner", status: "Aktivní", lastLogin: "dnes 06:12" },
  { id: 2, name: "Petr Janata", phone: "+420 777 987 654", role: "Manager", status: "Aktivní", lastLogin: "13. 4. 22:45" },
  { id: 3, name: "Michal Šulc", phone: "+420 776 555 000", role: "Head Trainer", status: "Pozván", lastLogin: "—" },
];
